import { SpacesRemainingTag } from 'Modules/FerrySchedule/Components/SpacesRemaining/SpacesRemainingTag';
import React from 'react';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';

import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { appConfigStore } from 'Models/AppConfigStore';
import { useIsFreightSpaceExceeded } from '../../Hooks/useIsFreightCapacityExceeded';
import { LegOptionContext } from './Contexts/LegOptionContext';

export default function LegOptionFreightCapacity() {
	const context = React.useContext(LegOptionContext);

	if (!context) {
		console.error('LegOptionContext is missing in LegOptionFreightCapacity');
		return null;
	}

	const { wizardData, trip } = context;

	if (wizardData.tabSelected !== 'freight') {
		return null;
	}

	return (
		<LegOptionFreightCapacityInner
			wizardData={wizardData}
			freightSpaces={1}
			closed={trip.freightBookingsClosed ?? false}
			showName={context.showCapacityNames}
			explainClosed={context.explainClosedCapacity}
			explainState={context.explainCapacityState}
		/>
	);
}

interface LegOptionFreightCapacityInnerProps {
	wizardData: BookingWizardData;
	freightSpaces: number;
	closed: boolean;
	/** Names the capacity beside its icon. See `showCapacityNames` on the leg-option context. */
	showName?: boolean;
	/** Explains `(closed)`. See `explainClosedCapacity` on the leg-option context. */
	explainClosed?: boolean;
	/** Tooltip describes the state, not the name. See `explainCapacityState` on the context. */
	explainState?: boolean;
}

function LegOptionFreightCapacityInner({
	wizardData,
	freightSpaces,
	closed,
	showName = false,
	explainClosed = false,
	explainState = false,
}: LegOptionFreightCapacityInnerProps) {
	// TODO freight capacity
	const exceedsAvailableFreightSpace = useIsFreightSpaceExceeded();

	return (
		<SpacesRemainingTag
			space={freightSpaces}
			capacityName="Freight"
			icon={<Icon name={appConfigStore.freightIconName} useMaterialIcons />}
			showCapacityRemaining={false}
			showName={showName}
			explainClosed={explainClosed}
			explainState={explainState}
			closed={closed}
			tooltipText={showName ? undefined : 'Freight'}
		/>
	);
}
